<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item v-if="!param.isgoods">
        <wcinput :option="{placeholder:'设置名称',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item v-if="param.isgoods">
        <div @click="searchGoods">
        <wcinput :option="{placeholder:'选择商品',clearable:true,ischange:true,width:'350px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.goodsname"
            @finish="(val)=> {}"
        />
        </div>
        </el-form-item>
        <el-form-item v-if="!param.isgoods">
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item v-if="!param.isgoods">
        <wcbutton :option="{title:'添加设置'}" @finish="$parent.JUMPVIEW({name:'EsAddRenew'})"/>
        </el-form-item>
        <el-form-item v-if="param.isgoods">
        <wcbutton :option="{title:'重置'}" 
            @finish="(val)=> {
                param.goodsid='';
                param.goodsname='';
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
        <el-form-item style="position:absolute;right:0;">
        <div class="TTL-switch" style="display:inline-flex;align-items:center;height:60px;">
        <el-switch v-model="param.isgoods" active-text="按置顶商品搜索" 
            @change="(val)=>{
                this.param.key='';
                this.param.goodsid='';
                this.param.goodsname='';
                this.param.change=true;
                GetList();
            }" 
        />
        </div>
        </el-form-item>
    </el-form>
</div>


<!-- 续费设置列表 -->
<div class="TTL-table top20" v-if="!param.isgoods">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column prop="name" label="续费名称" align="center">
            <template #default="scope">
                <div class="TTL-renewname" @click="$parent.JUMPVIEW({name:'EsRenewDetail',param:{id:scope.row.id}})">{{scope.row.name}}</div>
            </template>
        </el-table-column>
        <el-table-column label="作用区域" align="center">
            <template #default="scope">
                <span>{{scope.row.area_type}}</span>
            </template>
        </el-table-column>
        <el-table-column label="置顶时间" align="center">
            <template #default="scope">
                <span>{{scope.row.type==1 ? scope.row.nums+'条' : scope.row.timetype==1 ? scope.row.nums+'日' : scope.row.timetype==2 ? scope.row.nums+'月' : scope.row.nums+'年' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="置顶金额" align="center">
            <template #default="scope">
                <span class="renew-price">{{'￥'+scope.row.price}}</span>
            </template>
        </el-table-column>
        <el-table-column label="充值次数" align="center">
            <template #default="scope">
                <span class="renew-price">{{scope.row.orders}}</span>
            </template>
        </el-table-column>
        <el-table-column label="充值金额" align="center">
            <template #default="scope">
                <span class="renew-price">{{'￥'+scope.row.ordersprice}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="inputtime" label="添加时间" align="center"/>
        <el-table-column label="上下架" align="center">
            <template #default="scope">
                <el-switch v-model="scope.row.isshow" @change="ChangeShow(scope.row)" />
            </template>
        </el-table-column>
        <el-table-column label="排序" align="center">
            <template #default="scope">
                <div class="TTL-info">
                <wcinput :option="{placeholder:'排序',type:'input',ischange:true,width:'100px'}" 
                    :value="scope.row.sort"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            scope.row.sort=val.value;
                            ChangeSort(scope.row.id,scope.row.sort);
                        }
                    }"
                />
                </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="150">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'编辑'}" @finish="$parent.JUMPVIEW({name:'EsEditRenew',param:{id:scope.row.id}})" class="left10"/>
                <wcbutton :option="{title:'删除',type:'del'}" @finish="delrenew(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<!-- 续费商品利厄庇阿哦 -->
<div class="TTL-table top20" v-if="param.isgoods">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="置顶商品" align="center" min-width="150">
            <template #default="scope">
                <wcimage :option="{size:'middle'}" :value="scope.row.goodsthumb" />
            </template>
        </el-table-column>
        <el-table-column prop="goodsname" label="商品名称" align="center" min-width="120"/>
        <el-table-column label="首页累计置顶时长" align="center" min-width="150">
            <template #default="scope">
                <span>{{scope.row.idx_end_num=='' ? '/' : scope.row.idx_end_num}}</span>
            </template>
        </el-table-column>
        <el-table-column label="列表页累计置顶时长" align="center" min-width="150">
            <template #default="scope">
                <span>{{scope.row.list_end_num=='' ? '/' : scope.row.list_end_num}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="price" label="累计置顶金额" align="center" min-width="150">
            <template #default="scope">
                <span class="renew-price">{{'￥'+scope.row.end_price}}</span>
            </template>
        </el-table-column>
        <el-table-column label="当前首页置顶时间" align="center" min-width="280">
            <template #default="scope">
                <span>{{scope.row.endtime=='' ? '/' : scope.row.begintime+' ~ '+ scope.row.endtime}}</span>
                <span class="er-time-status" v-if="scope.row.endtime!=''">（{{scope.row.endtime_isexpire}}）</span>
            </template>
        </el-table-column>
        <el-table-column label="当前列表置顶时间" align="center" min-width="280">
            <template #default="scope">
                <span>{{scope.row.listtopend=='' ? '/' : scope.row.listtopbegin+' ~ '+scope.row.listtopend}}</span>
                <span class="er-time-status" v-if="scope.row.listtopend!=''">（{{scope.row.endtime_isexpire}}）</span>
            </template>
        </el-table-column>
        <el-table-column prop="transition_sn" label="原始微信支付单号" align="center" min-width="150"/>
        <el-table-column prop="inputtime" label="操作时间" align="center" min-width="150"/>
        <el-table-column label="操作" align="center" min-width="250" fixed="right">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'置顶记录',type:'del'}" @finish="renewlog(scope.row.goodsid)" class="left10"/>
                <wcbutton :option="{title:'退款'}" @finish="refundRenew(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>


<!-- 查看商品置顶记录 -->
<RenewGoodsLog :value="renewGoodslog.goodsid" :view="renewGoodslog.view" @finish="(val)=> {this.renewGoodslog.view=false;}" />
<!-- 商品置顶信息退款 -->
<RenewGoodsRefund 
    :value="refundComponet.id" 
    :view="refundComponet.view" 
    @finish="(val)=> {
        this.refundComponet.view=false;
        this.GetList();
    }" 
/>

</template>

<script>
import INTERFACE_MODEL_RENEW from '@/Interface/Es/Renew';
import RenewGoodsLog from '@/views/EsSetting/Module/RenewGoodsLog';
import RenewGoodsRefund from '@/views/EsSetting/Module/RenewGoodsRefund';
export default {

    components:{
        RenewGoodsLog,RenewGoodsRefund
    },

    data() {
        return {
            objloading:'renew',
            param: {
                isgoods:false,
                goodsid:'',
                goodsname:'',
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],
            renewGoodslog:{
                view:false,
                goodsid:'',
            },
            refundComponet: {
                view:false,
                id:'',
            },

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                if(data.param.type=='selectgoods') {
                    var data=data.param.data;
                    this.param.goodsid=data.id;
                    this.param.goodsname=data.name;
                    this.param.ischange=true;
                    this.GetList();

                }else {
                    this.GetList();
                }


            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var method=this.param.isgoods ? 'GET_RENEW_DETAIL_GOODS_LIST' : 'GET_RENEW_LIST';
            INTERFACE_MODEL_RENEW[method](this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
                 for(var i in this.list) this.list[i].isshow=this.list[i].isshow==1 ? true : false;
            });
        },


        /** 删除商品信息 **/
        delgoods(id) {
            INTERFACE_MODEL_RENEW.DEL_RENEW({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 修改排序 **/
        ChangeSort(id,sort) {
            INTERFACE_MODEL_RENEW.CHANGE_SORT({id:id,sort:sort}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 修改上下架 **/
        ChangeShow(renew) {
            var id=renew.id;
            var isshow=renew.isshow;
            isshow ? isshow=1 : isshow=0;
            INTERFACE_MODEL_RENEW.CHANGE_SHOW({id:id,isshow:isshow}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },

        
        /** 删除设置 **/
        delrenew(id) {
            INTERFACE_MODEL_RENEW.DEL_RENEW({ids:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },


        /** 搜索商品信息 **/
        searchGoods() {
            this.$parent.JUMPVIEW({name:'EsGoods',param:{childtype:'selectgoods',rollbackindex:0,rollbackobjname:'EsRenew'}})
        },


        /** 获取商品置顶信息列表 **/
        renewlog(goodsid) {
            this.renewGoodslog.goodsid=goodsid;
            this.renewGoodslog.view=true;
        },

        
        /** 置顶商品退款 **/
        refundRenew(id) {
            this.refundComponet.id=id;
            this.refundComponet.view=true;
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.TTL-info {display: inline-flex;justify-content: center;}
::v-deep(.TTL-info .TTL-input .el-input__inner) {text-align: center;}
.TTL-renewname {color:#666eeb;cursor: pointer;}
.renew-price {font-weight: bold;font-size:13px;}
.er-time-status {display: inline-block;width:100%;text-align: center;}
</style>